// pages/PersonalData/components/StepProgress/StepProgress.tsx
import React from 'react';
import './StepProgress.scss';

export interface Step {
  id: number;
  label: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  isCompleted?: boolean;
  isDisabled?: boolean;
}

interface StepProgressProps {
  currentStep: number;
  steps: Step[];
  onStepClick?: (step: number) => void;
  className?: string;
}

const StepProgress: React.FC<StepProgressProps> = ({
                                                     currentStep,
                                                     steps,
                                                     onStepClick,
                                                     className = ''
                                                   }) => {
  return (
    <div className={`step-progress ${className}`}>
      <div className="step-progress__container">
        {steps.map((step, index) => {
          const isActive = step.id === currentStep;
          const isCompleted = step.id < currentStep;
          const isDisabled = step.isDisabled || false;

          return (
            <React.Fragment key={step.id}>
              {/* Step indicator */}
              <div
                className={`
                                    step-progress__item 
                                    ${isActive ? 'step-progress__item--active' : ''}
                                    ${isCompleted ? 'step-progress__item--completed' : ''}
                                    ${isDisabled ? 'step-progress__item--disabled' : ''}
                                    ${onStepClick && !isDisabled ? 'step-progress__item--clickable' : ''}
                                `}
                onClick={() => {
                  if (onStepClick && !isDisabled) {
                    onStepClick(step.id);
                  }
                }}
              >
                <div className="step-progress__indicator">
                  {isCompleted ? (
                    <span className="step-progress__check">✓</span>
                  ) : (
                    <span className="step-progress__number">{step.id}</span>
                  )}
                </div>
                <div className="step-progress__content">
                  {step.icon && (
                    <span className="step-progress__icon">{step.icon}</span>
                  )}
                  <span className="step-progress__label">{step.label}</span>
                </div>
              </div>

              {/* Connector line between steps (except after last) */}
              {index < steps.length - 1 && (
                <div className={`
                                    step-progress__connector
                                    ${step.id < currentStep ? 'step-progress__connector--completed' : ''}
                                `} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepProgress;